import { Chipset } from '../components/types/stylepacks';
import { GetChipset, GetContentChipsDraft, SetChipset, UpsertContentChipsDraft } from '../connection/content-chips';
import { regenerateContent } from '../connection/generate-content';
import { FkTable, GeneratedContent } from '../stores/types/content';

export interface ResultItem {
  userId: number | null;
  graphicId: number;
  contentId: number | undefined;
}

export function buildContentFromFeeds(
  graphicIdByPresenterFeedIndex: Record<number, number | null>,
  generatedContent: GeneratedContent[]
): ResultItem[] {
  return generatedContent.reduce<ResultItem[]>((acc, content: GeneratedContent) => {
    if (
      content.fkTable === FkTable.graphics &&
      content.fkId &&
      graphicIdByPresenterFeedIndex[content.fkId]
    ) {
      acc.push({
        userId: graphicIdByPresenterFeedIndex[content.fkId],
        graphicId: content.fkId,
        contentId: content.id,
      });
    }
    return acc;
  }, []);
}

export async function processContentItems(
  items: ResultItem[],
  {
    channel,
    meetingId,
  }: {
    channel: number;
    meetingId: number;
  },
  isForShotEditorModal: boolean
): Promise<number[]> {
  const updatedContentIds: number[] = [];

  for (const item of items) {
    const { userId, contentId, graphicId } = item;
    if (!userId || !contentId || !graphicId) continue;

    if (isForShotEditorModal) {
      const chipsetDraftEntity = await GetContentChipsDraft(meetingId, contentId);
      const chipset = chipsetDraftEntity?.entityValue as Chipset;
      if (chipset && chipset?.gr_user !== userId) {
        await UpsertContentChipsDraft(meetingId, contentId, { ...chipset, gr_user: userId });
        await regenerateContent(meetingId, contentId);
      }
    } else {
      const chipset = await GetChipset(channel, contentId);
      if (chipset?.gr_user !== userId) {
        await SetChipset(channel, contentId, userId);
        await regenerateContent(meetingId, contentId);
      }
    }

    updatedContentIds.push(contentId);
  }
  return updatedContentIds;
}

export function areContentMapsEqual(
  a: Record<number, number | null> | null,
  b: Record<number, number | null>
): boolean {
  if (!a) return false;

  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) return false;

  for (const key of aKeys) {
    if (a[key as any] !== b[key as any]) return false;
  }

  return true;
}

